import OrderOptimizerDetailsCargoRequest, {
  OrderOptimizerDetailsCargoQueryParams,
} from "./order-optimizer-details-cargo.request";

const createQueryParams = (
  request: OrderOptimizerDetailsCargoRequest
): OrderOptimizerDetailsCargoQueryParams => {
  return {
    taxiDriverAssociationId: request.taxiDriverAssociationId,
    excludedOrders: request.excludedOrders,
  };
};

const orderOptimizerDetailsCargoRequestFactory = {
  createQueryParams,
};

export default orderOptimizerDetailsCargoRequestFactory;
